import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import MenuDataIntelligence from "../MenuDataIntelligence";
import PesquisaArtigo from "../PesquisaArtigo";

export default function HowImport() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>

                  <li className="breadcrumb-item active">
                    <a href="data-intelligence">Data Intelligence</a>
                  </li>

                  <li className="breadcrumb-item active">
                    Como enriquecer meus dados?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataIntelligence />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Como enriquecer meus dados?</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Intelligence</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Enriquecimento de Dados
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                {/* <div style={{ display: "flex", justifyContent: "center" }}>
                  <video controls width="550">
                    <source
                      src="mov/enriquecimento_de_dados_versão_final.mp4"
                      type="video/mp4"
                    />
                    Seu navegador não suporta a tag de vídeo.
                  </video>
                </div> */}

                <p>
                  Para enriquecer os seus dados através da nossa plataforma,
                  basta importar um arquivo .xlsx ou .csv contendo pelo menos um
                  campo de CPF, CNPJ ou e-mail.
                </p>

                <p>
                  Caso tenha dúvidas sobre as configurações do arquivo aceitas
                  pela plataforma, acesso o artigo{" "}
                  <a
                    href="/solucao-de-problemas-enriquecimento-com-erro-ou-pendencias"
                    target="blank"
                  >
                    Solução de problemas - Enriquecimento com erro ou pendências
                  </a>
                  . Veja a seguir como importar sua base.
                </p>

                <p>
                  <h3>Importando base Pessoa Física</h3>
                </p>

                <p>
                  Clique em <a style={{ fontWeight: "bold" }}>Analisar</a> no
                  menu superior e depois em{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PF</a>
                </p>

                <figure>
                  <img src="img/importar-base-pf-01.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  Agora clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Importar arquivo</a>
                </p>

                <figure>
                  <img src="img/importar-base-pf-02.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  Arraste ou selecione o arquivo que deseja importar e aceite a
                  opção de certificação Opt-in (certificando que os contatos
                  adicionados atendem a Lei Geral de Proteção de Dados (Lei
                  13.709 de 2018)). Saiba mais em nossa{" "}
                  <a
                    href="https://site.salesbox.com.br/privacidade"
                    target="blanck"
                  >
                    Política de Privacidade
                  </a>
                </p>

                <figure>
                  <img src="img/importar-base-pf-03.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  No segundo passo do processo de enriquecimento, o sistema
                  identificará o nome das colunas, selecione ao menos os campos
                  de e-mail ou CPF, como no exemplo abaixo (CPF igual a CPF):
                </p>

                <figure>
                  <img src="img/importar-base-pf-04.png" alt="excel" />
                </figure>

                <figcaption>Combinação de Campos</figcaption>

                <p>
                  Adicione campos personalizados! Por exemplo: Nome do seu
                  produto, Tipo de Cliente. Qualquer campo que seja importante
                  para a sua segmentação de perfil de clientes. Estes campos
                  personalizados permitirão que você segmente conforme seus
                  objetivos de negócios. Para criação destes campos, clique em
                  '+ Adicionar campo personalizado' e insira o nome do seu
                  campo:
                </p>

                <figure>
                  <img src="img/fieldcustomized.png" alt="excel" />
                </figure>

                <figcaption>Adicionar campos personalizado</figcaption>

                <p>
                  Para iniciar o processo de enriquecimento clique em 'Iniciar
                  importação' e aguarde o processo de tratamento e
                  enriquecimento:
                </p>

                <figure>
                  <img src="img/importar-base-pf-05.png" alt="excel" />
                </figure>

                <figcaption>Processo de Enriquecimento</figcaption>

                <p>
                  Acompanhe o processo de enriquecimento tambem na página de{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PF.</a> Os
                  status podem ser:{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecido</a>,{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecendo</a> ou{" "}
                  <a style={{ fontWeight: "bold" }}>Erro</a>.
                </p>

                <p>
                  Quando a base estiver com o status{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecido</a>, aparecerá
                  os botões{" "}
                  <a style={{ fontWeight: "bold" }}>Análise descritiva</a>,{" "}
                  <a style={{ fontWeight: "bold" }}>Análise de segmentação</a> e
                  as opções de exportar enriquecimento, relatório e excluir
                  arquivo.
                </p>

                <figure>
                  <img src="img/importar-base-pf-06.png" alt="excel" />
                </figure>

                <figcaption>Enriquecimento Completo</figcaption>

                <p>
                  <h3>Importando base Pessoa Jurídica</h3>
                </p>

                <p>
                  Clique em <a style={{ fontWeight: "bold" }}>Analisar</a> no
                  menu superior e depois em{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PJ</a>
                </p>

                <figure>
                  <img src="img/importar-base-pj-01.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  Agora clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Importar arquivo</a>
                </p>

                <figure>
                  <img src="img/importar-base-pj-02.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  Arraste ou selecione o arquivo que deseja importar e aceite a
                  opção de certificação Opt-in (certificando que os contatos
                  adicionados atendem a Lei Geral de Proteção de Dados (Lei
                  13.709 de 2018)). Saiba mais em nossa{" "}
                  <a
                    href="https://site.salesbox.com.br/privacidade"
                    target="blanck"
                  >
                    Política de Privacidade
                  </a>
                </p>

                <figure>
                  <img src="img/importar-base-pj-03.png" alt="excel" />
                </figure>

                <figcaption>Excel - Exemplo Importação </figcaption>

                <p>
                  No segundo passo do processo de enriquecimento, o sistema
                  identificará o nome das colunas, selecione ao menos os campos
                  de e-mail ou CNPJ, como no exemplo abaixo (CNPJ igual a CNPJ):
                </p>

                <figure>
                  <img src="img/importar-base-pj-04.png" alt="excel" />
                </figure>

                <figcaption>Combinação de Campos</figcaption>

                <p>
                  Para iniciar o processo de enriquecimento clique em 'Iniciar
                  importação' e aguarde o processo de tratamento e
                  enriquecimento:
                </p>

                <figure>
                  <img src="img/importar-base-pj-05.png" alt="excel" />
                </figure>

                <figcaption>Processo de Enriquecimento</figcaption>

                <p>
                  Acompanhe o processo de enriquecimento tambem na página de{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PJ.</a> Os
                  status podem ser:{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecido</a>,{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecendo</a> ou{" "}
                  <a style={{ fontWeight: "bold" }}>Erro</a>.
                </p>

                <p>
                  Quando a base estiver com o status{" "}
                  <a style={{ fontWeight: "bold" }}>Enriquecido</a>, aparecerá o
                  botão <a style={{ fontWeight: "bold" }}>Análise descritiva</a>{" "}
                  e as opções de exportar enriquecimento e relatório.
                </p>

                <figure>
                  <img src="img/importar-base-pj-06.png" alt="excel" />
                </figure>

                <figcaption>Enriquecimento Completo</figcaption>

                <p>
                  Caso ocorra algum erro ou a base seja enriquecida com
                  pendências, acesso o artigo{" "}
                  <a
                    href="/solucao-de-problemas-enriquecimento-com-erro-ou-pendencias"
                    target="blank"
                  >
                    Solução de problemas - Enriquecimento com erro ou pendências
                  </a>
                  .
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>

        <br></br>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
